import { Store } from '@ngrx/store';
import { BootstrapCompleteAction } from 'app/bootstrap/bootstrap.actions';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
var BootstrapService = /** @class */ (function () {
    function BootstrapService(store) {
        this.store = store;
    }
    BootstrapService.prototype.boostrapComplete = function () {
        this.store.dispatch(new BootstrapCompleteAction());
    };
    BootstrapService.ngInjectableDef = i0.defineInjectable({ factory: function BootstrapService_Factory() { return new BootstrapService(i0.inject(i1.Store)); }, token: BootstrapService, providedIn: "root" });
    return BootstrapService;
}());
export { BootstrapService };
